<template>
  <!--管理运营账号-->
  <el-dialog title="编辑账号" :visible.sync="showManage" width="30%" @close="$emit('update:show',false)">
    <el-form v-if="account" ref="form" :model="account" class="dialog-form" :rules="rules">
      <el-form-item label="账号" :label-width="formLabelWidth">
        {{ account.account }}
      </el-form-item>

      <el-form-item label="关联OA账号" :label-width="formLabelWidth">
        <span v-if="accountInfo.customer_number">{{ account.customer_number }}</span>
        <el-input v-else v-model="account.customer_number" type="text" autocomplete="off" />
      </el-form-item>

      <el-form-item label="使用者昵称" :label-width="formLabelWidth">
        <el-input v-model="account.real_name" type="text" autocomplete="off" />
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:show', false)">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit('form')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import { updateAdminAccount } from '@/api/adminAccount'
import { fetchStoreList } from '@/api/store'

export default {

  props: {
    accountInfo: {
      type: Object,
      default() {
        return {}
      }
    },

    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      remoteLoading: false,
      storeList: [],
      isShowStoreList: false,
      showManage: this.show, // 打开密码修改
      account: {
        account: '',
        real_name: '',
        role_id: '',
        platform_ids: [],
        store_id: undefined
      },
      formLabelWidth: '100',
      rules: {
        platform_ids: [{
          required: true,
          message: '请选择平台',
          trigger: 'blur'
        }],
        store_id: [{ required: true, message: '请选择使用门店', trigger: 'blur' }]
      }
    }
  },

  watch: {
    show(n) {
      this.showManage = this.show
    },
    accountInfo() {
      this.account = {
        ...this.accountInfo
      }
    }
  },

  methods: {
    onSubmit(name) {
      this.$refs[name].validate(valid => {
        console.log('store_id', this.account.store_id)
        if (valid) {
          const payload = {
            customer_number: this.account.customer_number,
            real_name: this.account.real_name
          }
          this.loading = true
          updateAdminAccount(this.account.id, payload).then(response => {
          // 关闭弹层
            this.$emit('update:show', false)
            // 更新数据
            this.$emit('updateInfo', response.data)
            this.$message({
              message: '更新账号信息成功',
              type: 'success',
              duration: 3 * 1000
            })
          }).finally(e => {
            this.loading = false
          })
        }
      })
    },
    // select远程搜索
    remoteMethod(query) {
      this.storeList = []
      if (query !== '') {
        this.remoteLoading = true
        this.fetchStoreList({ store_name: query })
      } else {
        // this.options = [];
        this.fetchStoreList()
      }
    },

    async fetchStoreList(params = {}) {
      try {
        const res = await fetchStoreList({
          ...params,
          limit: 50
        })
        this.storeList = _.get(res, ['data', 'data']) || []
        this.remoteLoading = false
        console.log(this.storeList)
      } catch (e) {
        console.log(e)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../../../styles/dialog-form.scss';
</style>
